import { FlexBox, Icon, Image, Lightbox, Text } from '@dixa/lib-shared-habla';
import { type FileUIPart } from 'ai';
import { useState } from 'react';

import {
  getAttachmentIcon,
  getAttachmentLabel,
  isImageAttachment,
} from '../../../../utils/sidekickAttachments';

import styles from './sidekickAttachmentTile.module.scss';
import { openAttachment } from './sidekickAttachmentTile.utils';

type SidekickAttachmentTileProps = {
  attachment: FileUIPart;
};

export const SidekickAttachmentTile = ({
  attachment,
}: SidekickAttachmentTileProps): JSX.Element => {
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const isImage = isImageAttachment(attachment);

  const handleClick = () => {
    if (isImage) {
      setIsPreviewOpen(true);
      return;
    }
    openAttachment(attachment);
  };

  return (
    <>
      <button type="button" className={styles.tile} onClick={handleClick}>
        {isImage ? (
          <Image src={attachment.url} alt="" className={styles.thumbnail} />
        ) : (
          <span className={styles.documentPreview}>
            <Icon name={getAttachmentIcon(attachment)} size={32} />
          </span>
        )}
        <FlexBox as="span" flexDirection="column" gap="100" padding="200">
          <Text.Paragraph as="span" variant="4" className={styles.text}>
            {attachment.filename}
          </Text.Paragraph>
          <Text.Paragraph
            as="span"
            variant="4"
            color="secondary"
            className={styles.text}
          >
            {getAttachmentLabel(attachment)}
          </Text.Paragraph>
        </FlexBox>
      </button>
      {isImage && (
        <Lightbox
          src={attachment.url}
          alt={attachment.filename}
          isOpen={isPreviewOpen}
          onClose={() => setIsPreviewOpen(false)}
        />
      )}
    </>
  );
};
